<div class="grid grid-cols-2 gap-3">
  <div class="col-span-2">
    <app-details-view label="Nazwa">
      {{ name() }}
    </app-details-view>
  </div>

  <app-details-view label="Numer artykułu (SKU)">
    {{ sku() }}
  </app-details-view>

  <app-details-view label="Właściciel">
    @if (ownerId() | fetchWarehouseOwnerById | async; as owner) {
      {{ owner.label }}
    } @else {
      <app-no-data />
    }
  </app-details-view>

  <app-details-view label="Marka kosmetyczna">
    {{ brand() }}
  </app-details-view>

  <app-details-view label="Produkt promocyjny">
    {{ promotion() | boolean }}
  </app-details-view>

  <app-details-view label="Rodzaj">
    {{ type() | warehouseProductType | async }}
  </app-details-view>

  <app-details-view label="Numer partii">
    @if (isNotNil(batchNumber())) {
      {{ batchNumber() }}
    } @else {
      <app-no-data />
    }
  </app-details-view>

  <app-details-view label="Ilość">
    {{ quantity() }}
  </app-details-view>

  <app-details-view label="Jednostka miary">
    <app-quantity-unit [unit]="unit()" />
  </app-details-view>

  <app-details-view label="Okres przydatności">
    @if (isNotNil(durabilityInformation())) {
      {{ durabilityInformation() }}
    } @else {
      <app-no-data />
    }
  </app-details-view>
</div>
